import React, { FunctionComponent, useCallback } from 'react';
import customerApi from '../../../../../common/api/customerApi';
import useWidgetContext from '../../../../../common/react/useWidgetContext';
import errorHandler from '../../../../../common/service/errorHandler';
import { offer } from '../../../../service/offer';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import currentDealSelectors from '../../../../store/selectors/currentDealSelectors';
import Save from '../../../presentational/actionButtons/customiseSave/Save';
import { useSelector } from 'react-redux';
import IActionButtonProps from '../IActionButtonProps';

const ExternalSave: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const currentDeal = useSelector(currentDealSelectors.getCurrentDeal);
  const isDisabled = currentDeal === null;
  const { eventContainer } = useWidgetContext();

  const carConfiguration = useSelector(carConfigurationSelectors.getConfiguration);

  const saveOffer = useCallback(() => {
    return customerApi
      .isLoggedIn()
      .then(({ data: { user } }) => {
        offer.externalSave(eventContainer, carConfiguration, user);
      })
      .catch(error => errorHandler.handleError(error));
  }, [carConfiguration]);

  return <Save onClick={saveOffer} disabled={isDisabled || config.disabled} />;
};

export default ExternalSave;
